import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMultisigStore } from '@/stores/multisig';
import { useWalletStore } from '@/stores/wallet';

function shortAddr(addr: string) {
  return addr.slice(0, 4) + '…' + addr.slice(-4);
}

export default function MultisigPicker() {
  const walletPubkey = useWalletStore((s) => s.pubkey);
  const list = useMultisigStore((s) => s.list);
  const activePda = useMultisigStore((s) => s.activePda);
  const select = useMultisigStore((s) => s.select);

  const [open, setOpen] = useState(false);

  const myMultisigs = walletPubkey
    ? list.filter((m) => m.ownerPubkey === walletPubkey)
    : [];
  const active = list.find((m) => m.multisigPda === activePda) ?? null;

  function pick(pda: string) {
    select(pda);
    setOpen(false);
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="rounded-lg border border-ink-800 bg-ink-900/60 px-3 py-1.5 text-sm text-ink-100 hover:bg-ink-800/60 transition-colors flex items-center gap-2"
      >
        {active ? (
          <span className="font-mono">{shortAddr(active.multisigPda)}</span>
        ) : (
          <span className="text-ink-300">No multisig</span>
        )}
        <span className="text-ink-400">▾</span>
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-72 rounded-xl border border-ink-800 bg-ink-900 shadow-2xl z-30 p-2"
          onClick={(e) => e.stopPropagation()}
        >
          {myMultisigs.length === 0 ? (
            <div className="p-3 text-sm text-ink-300">
              No multisigs yet for this wallet.
              <Link
                to="/app/setup"
                className="block mt-2 text-avo-400 hover:text-avo-300"
              >
                Create one →
              </Link>
            </div>
          ) : (
            <div className="space-y-1">
              {myMultisigs.map((m) => (
                <button
                  key={m.multisigPda}
                  type="button"
                  onClick={() => pick(m.multisigPda)}
                  className={[
                    'w-full text-left rounded-lg px-3 py-2 text-sm hover:bg-ink-800/80 transition-colors flex items-center justify-between',
                    m.multisigPda === activePda
                      ? 'bg-ink-800 text-ink-50'
                      : 'text-ink-200',
                  ].join(' ')}
                >
                  <span className="font-mono">{shortAddr(m.multisigPda)}</span>
                  {m.multisigPda === activePda && (
                    <span className="text-avo-400 text-xs">active</span>
                  )}
                </button>
              ))}
              <Link
                to="/app/setup"
                className="block px-3 py-2 text-sm text-ink-300 hover:text-ink-100 border-t border-ink-800 mt-1 pt-2"
              >
                + Create new multisig
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
